import React from 'react';
import ReactDOM from 'react-dom';

interface PortalWrapperProps {
  children?: React.ReactNode;
}

class PortalWrapper extends React.Component<PortalWrapperProps> {
  el: HTMLDivElement;

  constructor(props: any) {
    super(props);
    this.el = document.createElement('div');
  }

  // 2: Append the element to the DOM when it mounts
  componentDidMount = () => {
    const portalRoot = document.getElementById('portals');
    if (portalRoot) {
      portalRoot.appendChild(this.el);
    }
  };

  // 3: Remove the element when it unmounts
  componentWillUnmount = () => {
    const portalRoot = document.getElementById('portals');
    if (portalRoot) {
      portalRoot.removeChild(this.el);
    }
  };

  render() {
    // 4: Render the element's children in a Portal
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

export default PortalWrapper;
